import React, { useEffect } from 'react';
import { Toast, ToastKind } from './ui';
import './Notification.css';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationProps {
  id: string;
  type: NotificationType;
  title: string;
  message?: string;
  duration?: number;
  onClose: (id: string) => void;
}

const Notification: React.FC<NotificationProps> = ({
  id,
  type,
  title,
  message,
  duration = 5000,
  onClose,
}) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => onClose(id), duration);
      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  return (
    <div
      className={`cg-toast cg-toast--${type}`}
      style={{ ['--cg-toast-progress' as any]: `${duration}ms` }}
    >
      <Toast
        kind={type as ToastKind}
        title={title}
        message={message}
        onClose={() => onClose(id)}
      />
    </div>
  );
};

export default Notification;
